export class ButtonSettings {constructor(c={}) { 
  Object.assign(this, {
    text: 'Button',
    width: { type: 'auto', value: 1 },
    padding: { paddingLeft: 15, paddingRight: 15, paddingTop: 10, paddingBottom: 10 },
    margin: { marginLeft: 10, marginRight: 10, marginTop: 10, marginBottom: 10 },
    font: { fontSize: 14, fontWeight: '400', color: '#ffffff', fontFamily: 'arial, helvetica, sans-serif' },
    background: '#1890ff',
    border: { borderWidth: 0, borderColor: '#000000', borderTopLeftRadius: 5, borderTopRightRadius: 5, borderBottomLeftRadius: 5, borderBottomRightRadius: 5, borderStyle: 'solid' },
    choice_option: { type: null, data: {} },
  });
  Object.assign(this, c);
}}


export const ButtonTypes = {
  content: {
    text: { title: 'Text', type: 'Input' },
  },
  action: {
    choice_option: { title: 'Choice Option', type: 'ChoiceOptions' },
  },
  settings: {
    width: { title: 'Width', type: 'Size' },
    padding: { title: 'Padding', type: 'Padding' },
    margin: { title: 'Margin', type: 'Margin' },
  },
  styles: {
    font: { title: 'Font', type: 'Font' },
    background: { title: 'Background Color', type: 'ColorPicker' },
    border: { title: 'Border', type: 'Border' },
  }
};